<template>
  <div>
    <header
      class="header"
      v-if="
        $route.name !== 'Seat Layout' &&
        $route.name !== 'Food and Drinks Checkout' &&
        $route.name !== 'Booking Summary' &&
        $route.name !== 'Final Ticket' &&
        $route.name !== 'Regular Booking' &&
        $route.name !== 'Pay Now' &&
        $route.name !== 'Only Fnd Final Ticket'
      "
    >
      <!-- <div class="rainbow-line">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div> -->
      <!-- DESKTOP INTRO LINE -->
      <div class="header-intro d-none d-md-block">
        <!-- <div>
          <img
                  src="@/assets/logo-strip.jpg"
                  class="img-fluid"
                  alt="Miraj Logo"
                />
        </div> -->
        <div
          :class="
            window.width < 992
              ? 'header-content container-fluid'
              : 'header-content container'
          "
        >
          <div class="row">
            <div class="col-12 col-md-2 col-lg-2 col-xl-2">
              <router-link
                to
                @click.native="() => $router.push({ name: 'Home Page' })"
                :class="
                  window.width < 992 ? 'header-sm-logo' : 'header-brand-logo'
                "
              >
                <img
                  src="@/assets/logos/logo-2.png"
                  class="logo-new-img"
                  alt="Miraj Logo"
                />
              </router-link>
            </div>
            <div class="col-12 col-md-7 col-lg-7 col-xl-7 align-self-center">
              <div class="row">
                <div class="col-md-8 align-self-center">
                  <form @submit.prevent.stop="">
                    <input
                      @input="onSearch($event.target.value)"
                      type="search"
                      v-model="searchText"
                      class="form-control header-search"
                      placeholder="Search movies or theatres..."
                    />
                  </form>

                  <div class="search-result-box" v-if="searchText.length > 0">
                    <div class="jm-wrapper">
                      <ul class="search-result-list">
                        <li
                          v-for="(searchLoop, searchLoopKey) in searchedMovies"
                          :key="searchLoopKey"
                        >
                          <router-link
                            to
                            @click.native="
                              handleClick(
                                searchLoop.Film_strCode
                                  ? {
                                      code: searchLoop.Film_strCode,
                                      type: 'movie',
                                    }
                                  : {
                                      code: searchLoop.Cinema_strID,
                                      type: 'cinema',
                                    }
                              )
                            "
                          >
                            <div class="row mh-auto">
                              <div class="col-md-3">
                                <img
                                  v-lazy="IMAGE_URL + searchLoop.image_path_1"
                                  class="img-fluid"
                                  alt
                                />
                              </div>
                              <div class="col-md-9 pl-0 align-self-center">
                                <div class="font-weight-500">
                                  {{
                                    searchLoop.Film_strTitle
                                      ? searchLoop.Film_strTitle
                                      : searchLoop.Cinema_strName
                                  }}
                                </div>
                                <ul
                                  class="dot-list small font-weight-light"
                                  v-if="searchLoop.Film_strTitle"
                                >
                                  <li>
                                    {{
                                      searchLoop.language_name
                                        ? searchLoop.language_name
                                        : null
                                    }}
                                  </li>
                                  <li>
                                    {{
                                      searchLoop.genre_name
                                        ? searchLoop.genre_name
                                        : null
                                    }}
                                  </li>
                                  <li>
                                    {{
                                      searchLoop.Film_strTitle
                                        ? searchLoop.Film_strCensor[0] &&
                                          searchLoop.Film_strCensor[0]
                                        : null
                                    }}
                                  </li>
                                  <li v-if="searchLoop.Film_strTitle">
                                    {{
                                      searchLoop.Film_strTitle &&
                                      searchLoop.Film_intDuration
                                        | durationInHours
                                    }}hr{{
                                      searchLoop.Film_strTitle &&
                                      searchLoop.Film_intDuration
                                        | durationInMins
                                    }}min
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </router-link>
                        </li>
                      </ul>
                      <div class="single-movie"></div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-lg-4 col-xl-4 pl-0 align-self-center">
                  <form>
                    <div
                      class="has-chevron"
                      :class="locationContent ? 'chevron-inverse' : ''"
                    >
                      <input
                        ref="locationSearch"
                        id="locationSearch"
                        type="search"
                        placeholder="Select Location"
                        :v-model="usersLocation"
                        :value="usersLocation"
                        @focus="openLocationPopup"
                        class="form-control header-select-location"
                        @input="getLocations($event.target.value)"
                        style="cursor:pointer"

                      />
                    </div>
                  </form>
                  <div
                    class="select-location-box city-search-box py-2"
                    v-if="locationContent"
                  >
                    <!-- locationContent -->
                    <!-- @mouseleave="locationContent = !locationContent" -->
                    <div class="mb-2" v-for="(a, b) in locations" :key="b">
                      <p class="px-2 mb-0 state">
                        {{ a.States[0].state_name }}
                      </p>
                      <ul class="search-result-list mb-0">
                        <li
                          class="cursor-pointer"
                          v-for="(c, d) in a.States"
                          :key="d + 'State_index'"
                        >
                          <span
                            class="city mb-0 w-100 d-block"
                            @click="
                              handleLocationChange(c.city_id, c.city_name)
                            "
                            >{{ c.city_name }}</span
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-12 col-md-3 col-lg-3 col-xl-3 align-self-center text-right"
            >
              <!-- NOT LOGGED IN SECTION -->
              <div
                :class="[' ', getIsUserLogged ? 'd-none' : null]"
                v-if="!getIsUserLogged"
              >
                <button
                  @click="onHandleOpenModal('signInModal')"
                  class="btn btn-primary"
                >
                  Sign In
                </button>
                <span class="mx-1 d-md-none"></span>
                <button
                  class="btn btn-outline-primary"
                  @click="onHandleOpenModal('signUpModal')"
                >
                  Register
                </button>
              </div>

              <!-- LOGGED IN SECTION -->
              <b-dropdown
                v-else
                variant="transparent"
                :class="[
                  'edirProfileDropdown ',
                  !getIsUserLogged ? 'd-none' : null,
                ]"
                no-caret
                right
              >
                <template v-slot:button-content>
                  <div class="d-flex align-items-center">
                    <img v-lazy="getImageObject()" height="43" width="43" alt />

                    <div class="text-left ml-2 text-white">
                      <div>Hello</div>
                      <div class="lh-1 text-capitalize">
                        {{
                          getIsUserLogged && getLoggedUser["user_name"]
                            ? getLoggedUser["user_name"]
                            : "Guest"
                        }}
                        <span>
                          <img
                            src="@/assets/img/icons/down-arrow-white.svg"
                            height="6"
                            width="12"
                            alt
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
                <b-dropdown-item>
                  <!-- <img
                    v-lazy="getImageObject()"
                    height="18"
                    width="18"
                    alt="User Icon"
                  /> -->
                  <img
                    src="@/assets/img/icons/user-white.svg"
                    height="18"
                    width="18"
                    alt="User Icon"
                  />
                  <span>&nbsp;</span>
                  <span
                    @click="
                      $router.push({
                        name: 'User Profile',
                        params: { component_name: 'editProfile' },
                      })
                    "
                    >Edit Profile</span
                  >
                </b-dropdown-item>
                <b-dropdown-item>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div>
                      <img
                        width="18"
                        height="18"
                        alt="Notification Icon"
                        src="@/assets/img/icons/notificationIcon.svg"
                      />
                      <span>&nbsp;</span>
                      <span
                        @click="
                          getIsUserLogged
                            ? $router.push({
                                name: 'User Profile',
                                params: { component_name: 'notifications' },
                              })
                            : null
                        "
                        >Notification</span
                      >
                    </div>
                    <div
                      class="notificationNum"
                      v-if="
                        getLoggedUser &&
                        getUnreadNotificationCount > 0 &&
                        getUnreadNotificationCount
                      "
                    >
                      {{ getUnreadNotificationCount }}
                    </div>
                  </div>
                </b-dropdown-item>
                <b-dropdown-item>
                  <img
                    width="18"
                    height="18"
                    alt="Notification Icon"
                    src="@/assets/img/icons/bookingIcon.svg"
                  />
                  <span>&nbsp;</span>
                  <span
                    @click="
                      getIsUserLogged
                        ? $router.push({
                            name: 'User Profile',
                            params: { component_name: 'myTransactions' },
                          })
                        : null
                    "
                    >My Bookings</span
                  >
                </b-dropdown-item>
                <!-- <b-dropdown-item>
                  <img
                    width="18"
                    height="18"
                    alt="Notification Icon"
                    src="@/assets/img/icons/wallet.svg"
                  />
                  <span>&nbsp;</span> 
                  <span>Saved Payment</span> 
                </b-dropdown-item> -->

                <b-dropdown-item class="text-center">
                  <button class="btn btn-outline-primary" @click="onLogoutUser">
                    Sign out
                  </button>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>

      <!-- DESKTOP NAVIGATION LINKS -->
      <nav class="header-navigation d-none d-md-block">
        <div class="container">
          <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 mx-auto">
            <div class="header-navigation-links">
              <div>
                <router-link
                  to
                  title="Movies"
                  @click.native="() => $router.push({ name: 'Movies' })"
                  :class="$route.path == '/movies' ? 'active' : ''"
                >
                  <span class="textbold">Movies</span>
                </router-link>
              </div>
              <div>
                <router-link
                  to
                  title="Cinemas"
                  @click.native="() => $router.push({ name: 'Cinemas' })"
                  :class="$route.path == '/cinemas' ? 'active' : ''"
                >
                  <span class="textbold">Cinemas</span>
                </router-link>
              </div>
              <div>
                <router-link
                  to
                  title="Offers"
                  @click.native="() => $router.push({ name: 'Offers' })"
                  :class="$route.path == '/offers' ? 'active' : ''"
                >
                  <span class="textbold">Offers</span>
                </router-link>
              </div>
              <div>
                <router-link
                  to
                  title="Experiences"
                  @click.native="() => $router.push({ name: 'Cinema Experiences' })"
                  :class="
                    $route.path == '/cinema-experiences' ? 'active textbold' : 'textbold'
                  "
                  >Experiences</router-link
                >
              </div>
              <!-- Food And Drinks -->
              <!-- <div>
                <router-link
                  to
                  @click.native="
                    () =>
                      $router.push({
                        name: 'Food And Drinks',
                        params: { cinema_code: 0 }
                      })
                  "
                  title="Food and Drinks"
                  :class="$route.path == '/food-and-drinks' ? 'active' : ''"
                >
                  <span>Food &amp; Beverages</span>
                </router-link>
              </div> -->
              <!-- Promos And Offers -->
              <!-- <div>
                <router-link
                  to
                  @click.native="
                    () => $router.push({ name: 'Offers And Promotions' })
                  "
                  title="Promotions and Offers"
                  :class="
                    $route.path == '/offers-and-promotions' ? 'active' : ''
                  "
                >
                  <span>Promos &amp; Offers</span>
                </router-link>
              </div> -->
              <div>
                <router-link
                  to
                  title="Advertise With Us"
                  @click.native="
                    () => $router.push({ name: 'Advertise With Us' })
                  "
                  :class="
                    $route.path == '/advertise-with-us'
                      ? 'active textbold'
                      : 'textbold'
                  "
                  >Advertise With Us</router-link
                >
              </div>
              <div>
                <router-link
                  to
                  title="About Us"
                  @click.native="() => $router.push({ name: 'About Us' })"
                  :class="
                    $route.path == '/about-us' ? 'active textbold' : 'textbold'
                  "
                  >About Us</router-link
                >
              </div>

              <!-- <div>
                <router-link
                  to
                  title="Safety Precaution"
                  @click.native="
                    () => $router.push({ name: 'Safety Precautions' })
                  "
                  :class="$route.path == '/safety' ? 'active' : ''"
                  >Safety Precaution</router-link
                >
              </div> -->
            </div>
          </div>
        </div>
      </nav>

      <div class="header-intro-mobile d-md-none">
        <div class>
          <router-link
            to
            @click.native="() => $router.push({ name: 'Home Page' })"
          >
            <img
              src="@/assets/logos/logo-2.png"
              alt="Miraj Logo"
              class="mobile-logo"
            />
          </router-link>

          <span class="cursor-pointer" @click="openLocationPopup">
            {{ getLocation }}
            <img
              src="@/assets/img/icons/down-arrow-black.svg"
              class="ml-1"
              alt
            />
          </span>
        </div>

        <div>
          <button
            class="btn btn-transparent"
            v-on:click="asideSearch = !asideSearch"
          >
            <b-icon
              icon="search"
              font-scale="1.3"
              class="search-icon"
              style="color: white"
            ></b-icon>
          </button>

          <button
            class="btn-open-asideNavigation"
            v-on:click="onOpenAsideNavigation"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>

    <!-- MOBILE SIDE NAVIGATION -->
    <aside
      class="aside-navigation"
      :class="getAsideNavigation ? 'is-active' : null"
    >
      <div class="rainbow-line">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div class="aside-navigation-content flex-grow-1">
        <!-- WITHOUT LOGIN SECTION -->
        <!-- <section class="d-flex mb-5">
          <div class="w-75 d-flex">
            <button class="btn btn-sm btn-danger w-50">Sign In</button>
            <div class="mx-2"></div>
            <button class="btn btn-sm btn-outline-primary w-50">Sign Up</button>
          </div>
          <div class="w-25">
            <button class="btn-close-aside" v-on:click="asideNavigation = !asideNavigation">&times;</button>
          </div>
        </section>-->

        <section class="d-flex flex-wrap mb-4">
          <!-- BEFORE USER LOGIN -->
          <div :class="['w-75 ', getIsUserLogged ? 'd-none' : null]">
            <button
              class="btn btn-primary"
              @click="onHandleOpenModal('signInModal')"
            >
              Sign In
            </button>
            <span class="mx-1"></span>
            <button
              class="btn btn-outline-primary"
              @click="onHandleOpenModal('signUpModal')"
            >
              Register
            </button>
          </div>
          <!-- AFTER USER LOGIN -->
          <div :class="['w-75 ', !getIsUserLogged ? 'd-none' : null]">
            <router-link
              @click.native="
                () => {
                  onOpenAsideNavigation();
                  $router.push({ path: '/userProfile/editProfile' });
                }
              "
              to=""
            >
              <div class="d-flex align-items-center">
                <img
                  src="@/assets/img/icons/user.svg"
                  height="35"
                  width="35"
                  alt="Account User"
                />
                <span>&nbsp;</span>
                <div class="text-white m-2 h5">
                  Hi
                  {{
                    getLoggedUser && getLoggedUser["user_name"]
                      ? getLoggedUser["user_name"]
                      : "Guest"
                  }}
                </div>
              </div>
            </router-link>
          </div>

          <div class="w-25 align-self-center">
            <button class="btn-close-aside" v-on:click="onOpenAsideNavigation">
              &times;
            </button>
          </div>

          <div class="w-100 border-bottom pb-4 d-none">
            <ul class="list-unstyled userDropdownMenu my-4">
              <li class="mb-4">
                <router-link to>
                  <img
                    src="@/assets/img/icons/user.svg"
                    height="18"
                    width="18"
                    alt
                  />
                  <span class="pl-2">My Profile</span>
                </router-link>
              </li>
              <li class="mb-4">
                <router-link
                  to
                  @click.native="
                    () =>
                      $router.push({
                        name: 'User Profile',
                        params: { component_name: 'notifications' },
                      })
                  "
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div>
                      <img
                        src="@/assets/img/icons/notification.svg"
                        height="18"
                        width="18"
                        alt
                      />
                      <span class="pl-2">Notification</span>
                    </div>
                    <div class="notificationNum">1</div>
                  </div>
                </router-link>
              </li>
              <li class="mb-4">
                <router-link to>
                  <img
                    src="@/assets/img/icons/transaction.svg"
                    height="18"
                    width="18"
                    alt
                  />
                  <span class="pl-2">My Transaction</span>
                </router-link>
              </li>
            </ul>
            <button class="btn btn-outline-primary" @click="onLogoutUser">
              Sign out
            </button>
          </div>
        </section>

        <!-- Profile Ajay-->
        <ul class="list-unstyled mb-0">
          
          <div :class="[' ', !getIsUserLogged ? 'd-none' : null]">
 
          <li>
            <router-link
            @click.native="
                () => {
                  onOpenAsideNavigation();
                  $router.push({ path: '/userProfile/editProfile' });
                }
              "
              :class="$route.path == '/userProfile/editProfile' ? 'active' : ''"
              to="" >
              Edit Profile
            </router-link>
          </li>
          <li>
            <router-link
              @click.native="
                  () => {
                    onOpenAsideNavigation();
                    $router.push({ path: '/userProfile/notifications' });
                  }
                "
                :class="$route.path == '/userProfile/notifications' ? 'active' : ''"
                to="" >
                Notification
            </router-link>
          </li>
          <li>
            <router-link
              @click.native="
                  () => {
                    onOpenAsideNavigation();
                    $router.push({ path: '/userProfile/myTransactions' });
                  }
                "
                :class="$route.path == '/userProfile/myTransactions' ? 'active' : ''"
                to="" >
                My Bookings
            </router-link>
          </li>
          <li></li>
        </div>
        </ul>
      <!-- Profile Ajay -->
      <hr class="my-4" />

        <ul class="list-unstyled mb-0">
          <li>
            <router-link
              to
              @click.native="
                () => {
                  onOpenAsideNavigation();
                  $router.push({ name: 'Movies' });
                }
              "
              :class="$route.path == '/movies' ? 'active' : ''"
              >Movies</router-link
            >
          </li>
          <li>
            <router-link
              to
              @click.native="
                () => {
                  onOpenAsideNavigation();
                  $router.push({ name: 'Cinemas' });
                }
              "
              :class="$route.path == '/cinemas' ? 'active' : ''"
              >Cinemas</router-link
            >
          </li>
          <li>
            <router-link
              to
              @click.native="
                () => {
                  onOpenAsideNavigation();
                  $router.push({ name: 'Offers' });
                }
              "
              :class="$route.path == '/offers' ? 'active' : ''"
              >Offers</router-link
            >
          </li>
          <li>
            <router-link
              to
              @click.native="
                () => {
                  onOpenAsideNavigation();
                  $router.push({ name: 'Cinema Experiences' });
                }
              "
              :class="$route.path == '/cinema-experiences' ? 'active' : ''"
              >Experiences</router-link
            >
          </li>

          <!-- <li>
            <router-link
              to
              @click.native="
                () => {
                  onOpenAsideNavigation();
                  $router.push({
                    name: 'Food And Drinks',
                    params: { cinema_code: 0 },
                  });
                }
              "
              :class="$route.path == '/food-and-drinks' ? 'active' : ''"
              >Food & Beverages</router-link
            >
          </li> -->
          <!-- <li>
            <router-link
              to
              @click.native="
                () => {
                  onOpenAsideNavigation();
                  $router.push({ name: 'Offers And Promotions' });
                }
              "
              :class="$route.path == '/promotions-and-offers' ? 'active' : ''"
              >Promos & Offers</router-link
            >
          </li> -->
          <li>
            <router-link
              @click.native="
                () => {
                  onOpenAsideNavigation();
                  $router.push({ name: 'Advertise With Us' });
                }
              "
              to
              :class="$route.path == '/advertise-with-us' ? 'active' : ''"
              >Advertise with us</router-link
            >
          </li>
          <!-- <li>
            <router-link
              @click.native="
                () => {
                  onOpenAsideNavigation();
                  $router.push({ name: 'Safety Precautions' });
                }
              "
              to
              :class="$route.path == '/safety' ? 'active' : ''"
              >Safety Precautions</router-link
            >
          </li> -->
        </ul>

        <hr class="my-4" />

        <ul class="list-unstyled mb-4">
          <li>
            <router-link
              @click.native="
                () => {
                  onOpenAsideNavigation();
                  $router.push({ name: 'About Us' });
                }
              "
              to
              >About Us</router-link
            >
          </li>
          <li>
            <router-link
              @click.native="
                () => {
                  onOpenAsideNavigation();
                  $router.push({ name: 'Contact Us' });
                }
              "
              to
              >Contact Us</router-link
            >
          </li>
          <li>
            <router-link
              @click.native="
                () => {
                  onOpenAsideNavigation();
                  $router.push({ name: 'Careers' });
                }
              "
              to
              >Careers</router-link
            >
          </li>
        </ul>

        <ul class="list-unstyled mb-4">
          <li>
            <router-link
              @click.native="
                () => {
                  onOpenAsideNavigation();
                  $router.push({ name: 'Terms and Conditions' });
                }
              "
              to
              class=""
              >Terms & Conditions</router-link
            >
          </li>
          <!-- <li>
            <router-link
              @click.native="
                () => {
                  onOpenAsideNavigation();
                  $router.push({ name: 'Refunds And Cancellation' });
                }
              "
              to
              class=""
              >Refunds & Cancellations</router-link
            >
          </li> -->
        </ul>

        <ul class="list-unstyled mb-0">
          <li style="color: #fff">
            Folow Us
            <ul class="list-inline mt-2">
              <li class="list-inline-item">
                <a
                  href="https://www.facebook.com/MirajCinemas/"
                  target="_blank"
                  title="Facebook"
                >
                  <svg
                    width="29"
                    height="29"
                    viewBox="0 0 29 29"
                    fill=" #e7beb3"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M28.9999 14.4739C29.026 22.4658 22.5323 28.9739 14.5521 28.9999C6.51977 29.026 0 22.5179 0 14.5C0 6.48203 6.49369 0 14.4739 0C22.4802 0 28.9738 6.456 28.9999 14.4739ZM12.1268 14.4219C12.1268 17.4416 12.1268 20.3572 12.1268 23.2989C13.3786 23.2989 14.5782 23.2989 15.83 23.2989C15.83 20.3312 15.83 17.4156 15.83 14.4219C16.6906 14.4219 17.473 14.4219 18.3075 14.4219C18.4118 13.3545 18.5161 12.3653 18.6205 11.298C17.6555 11.298 16.7688 11.298 15.8039 11.298C15.8039 10.6472 15.8039 10.0745 15.8039 9.50177C15.83 8.82493 16.0647 8.59064 16.7688 8.59064C17.3426 8.59064 17.9163 8.59064 18.5422 8.59064C18.5422 7.54935 18.5422 6.58616 18.5422 5.54487C17.5512 5.54487 16.6124 5.4928 15.6474 5.54487C13.3003 5.70106 12.1268 6.97664 12.1007 9.31954C12.1007 9.97035 12.1007 10.6212 12.1007 11.324C11.4748 11.324 10.9271 11.324 10.3534 11.324C10.3534 12.3913 10.3534 13.4066 10.3534 14.4479C10.9532 14.4219 11.4748 14.4219 12.1268 14.4219Z"
                      fill="#fff"
                    />
                  </svg>
                </a>
              </li>
              <li class="list-inline-item">
                <a
                  href="https://twitter.com/MirajCinemas"
                  target="_blank"
                  title="Twitter"
                >
                  <svg
                    width="29"
                    height="29"
                    viewBox="0 0 29 29"
                    fill=" #e7beb3"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.474 7.78957e-05C22.4256 -0.0259777 28.948 6.48791 28.9999 14.4349C29.0259 22.3818 22.5035 28.9739 14.5779 28.9999C6.54837 29.026 0 22.486 0 14.487C0 6.54002 6.4964 0.0261335 14.474 7.78957e-05ZM7.97758 16.8841C8.44532 18.3953 9.66664 18.9425 11.1478 19.4375C10.5242 19.7763 10.1344 20.0629 9.69262 20.2192C8.67918 20.5579 7.63976 20.7924 6.54837 21.1051C6.83421 21.2614 7.12005 21.4699 7.43188 21.6001C13.3306 24.2057 20.2168 20.6621 21.5421 14.3306C21.8539 12.8194 21.646 11.1258 23.1532 10.0054C22.7634 10.0836 22.3736 10.1357 21.8799 10.2139C22.2697 9.64064 22.6075 9.19769 22.9193 8.72869C22.8673 8.62447 22.8413 8.49419 22.7894 8.38997C21.646 9.35403 20.6845 8.91108 19.5671 8.41603C18.7616 8.05125 17.5922 8.10336 16.7347 8.38997C14.9417 8.98925 14.474 10.6047 14.474 12.4546C11.4337 12.3765 9.12094 10.8913 7.06808 8.80686C6.28851 10.6047 6.6783 12.0638 7.97758 13.4708C7.43188 13.4447 7.06808 13.4187 6.65231 13.3666C6.73027 15.0862 7.76969 15.9982 9.1989 16.7538C8.67919 16.7799 8.36736 16.832 7.97758 16.8841Z"
                      fill="#fff"
                    />
                  </svg>
                </a>
              </li>
              <li class="list-inline-item">
                <a
                  href="https://www.instagram.com/p/Bl7ODnfgg_-/?utm_source=ig_embed"
                  target="_blank"
                  title="Instagram"
                >
                  <svg
                    width="29"
                    height="29"
                    viewBox="0 0 29 29"
                    fill=" #e7beb3"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.5391 7.89082e-05C22.5901 0.0261579 29.0518 6.49375 28.9997 14.4739C28.9476 22.5584 22.4598 29.026 14.4088 28.9999C6.46198 28.9738 -0.0517998 22.3759 0.000310502 14.4218C0.0263657 6.41551 6.54015 -0.0260001 14.5391 7.89082e-05ZM6.67042 14.5522C6.67042 15.6736 6.64437 16.821 6.67042 17.9424C6.72253 20.6286 8.3119 22.3498 11.0216 22.4541C13.2884 22.5323 15.5292 22.5323 17.796 22.4541C20.5057 22.3498 22.0951 20.6546 22.1472 17.9424C22.1732 15.7257 22.1732 13.509 22.1472 11.2923C22.0951 8.60615 20.4015 6.88493 17.7439 6.83278C15.5292 6.8067 13.3145 6.78062 11.0998 6.83278C8.44217 6.88493 6.74859 8.60615 6.67042 11.2923C6.64437 12.3876 6.67042 13.4568 6.67042 14.5522Z"
                      fill="#fff"
                    />
                    <path
                      d="M20.9882 14.5357C20.9882 15.7252 21.0147 16.9148 20.9882 18.1043C20.9352 19.6903 19.9804 20.827 18.4158 20.9063C15.8698 21.012 13.2974 21.0384 10.7515 20.9327C9.05417 20.8534 8.04641 19.6903 8.01989 17.9721C7.99337 15.6988 7.99337 13.3991 8.01989 11.1258C8.04641 9.24899 9.05417 8.11234 10.9371 8.05948C13.3239 7.98017 15.7107 7.98017 18.071 8.05948C19.9009 8.13878 20.9617 9.32829 20.9882 11.1522C20.9882 12.236 20.9882 13.3727 20.9882 14.5357ZM14.4112 10.4649C12.1835 10.4914 10.3537 12.2889 10.3802 14.5093C10.4067 16.6769 12.2896 18.5272 14.4643 18.5272C16.7185 18.5272 18.6279 16.5976 18.5749 14.4036C18.5218 12.2096 16.6654 10.4385 14.4112 10.4649ZM18.7075 8.93179C18.2832 9.53976 17.8323 9.90984 17.8588 10.227C17.8854 10.5442 18.4158 11.0729 18.734 11.0465C19.0522 11.0465 19.5826 10.5178 19.6092 10.2006C19.6092 9.8834 19.1318 9.51333 18.7075 8.93179Z"
                      fill="#fff"
                    />
                    <path
                      d="M17.9995 13.97C17.9995 15.6497 16.5596 17.0295 14.9398 16.9995C13.3799 16.9395 12 15.5298 12 13.97C12 12.3203 13.4099 10.9705 15.0897 11.0005C16.7396 11.0305 18.0295 12.3203 17.9995 13.97Z"
                      fill="#fff"
                    />
                  </svg>
                </a>
              </li>
              <li class="list-inline-item social-icon">
                <a
                  href=" https://www.youtube.com/channel/UCkWN8rey8MQaEr_YMVIUcyg"
                  target="_blank"
                  title="Youtube"
                  ><i class="bi bi-youtube"></i
                ></a>
              </li>
              <li class="list-inline-item social-icon">
                <a
                  href=" https://www.linkedin.com/company/miraj-entertainment-ltd/"
                  target="_blank"
                  title="Linkedin"
                  ><i class="bi bi-linkedin"></i
                ></a>
              </li>
            </ul>
          </li>
        </ul>

        <hr class="my-4" />

        <div>
          <p class="mb-0 fs-14">Customer Care</p>
          <ul class="list-inline mb-0">
            <!-- <li class="list-inline-item my-0 mr-0">
              <a class="fs-14" href="tel:+918657029478">+91 86570 29478</a>
            </li>
            <li class="list-inline-item my-0 mr-0 fs-14">|</li> -->
            <li class="list-inline-item my-0 mr-0">
              <a
                class="fs-14"
                :href="`mailto:${plainEmail || 'contactus@mirajcinemas.com'}`"
                target="_blank"
                >{{ plainEmail || 'contactus@mirajcinemas.com' }}</a
              >
            </li>
          </ul>
        </div>

        <p class="copyright-text text-left my-3 fs-14">
          © Miraj Cinemas {{ new Date().getFullYear() }} All Rights Reserved.
        </p>
      </div>

      <div class="rainbow-line">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </aside>

    <!-- MOBILE SEARCH SECTION -->
    <section class="aside-search" :class="asideSearch ? 'is-active' : null">
      <div class="rainbow-line">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="aside-search-content">
        <form>
          <div class="d-flex mb-3">
            <div class="search-bar">
              <b-icon icon="search" font-scale="1.3"></b-icon>
              <input
                @input="onSearch($event.target.value)"
                type="search"
                v-model="searchText"
                placeholder="Search by movie title, theatre name"
              />
            </div>
            <button
              class="btn-close-aside mt-1"
              v-on:click.prevent="asideSearch = !asideSearch"
            >
              &times;
            </button>
          </div>
          <!-- SEARCH RESULT -->
          <div>
            <div class="row mt-5">
              <div
                class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3 evenSpacing"
                v-for="(searchLoop, searchLoopKey) in searchedMovies"
                :key="searchLoopKey"
              >
                <div
                  @click="
                    handleClick(
                      searchLoop.Film_strCode
                        ? {
                            code: searchLoop.Film_strCode,
                            type: 'movie',
                          }
                        : {
                            code: searchLoop.Cinema_strID,
                            type: 'cinema',
                          }
                    )
                  "
                  class="movie-listing-card"
                >
                  <div class="movie-card-img-box">
                    <img
                      v-lazy="IMAGE_URL + searchLoop.image_path_1"
                      class="img-fluid"
                      alt
                    />
                  </div>

                  <div class="movie-content">
                    <div>
                      <div title="Malang" class="movie-title">
                        <span>{{
                          searchLoop.Film_strTitle
                            ? searchLoop.Film_strTitle
                            : searchLoop.Cinema_strName
                        }}</span>
                      </div>

                      <ul class="dot-list" v-if="searchLoop.Film_strTitle">
                        <li>
                          {{
                            searchLoop.language_name
                              ? searchLoop.language_name
                              : null
                          }}
                        </li>
                        <li>
                          {{
                            searchLoop.genre_name ? searchLoop.genre_name : null
                          }}
                        </li>
                        <li>
                          {{
                            searchLoop.Film_strTitle
                              ? searchLoop.Film_strCensor[0] &&
                                searchLoop.Film_strCensor[0]
                              : null
                          }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>

    <section class="mobile-location-modal"></section>

    <!--     
    <b-modal id="signIn" title="Login to Miraj" hide-footer>
      <div>
        <div class="p-3">
          <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
            <div class="row">
              <div class="col-6 my-3">
                <router-link to>
                  <img
                    class="img-fluid"
                    alt="Facebook Login"
                    src="@/assets/img/icons/facebook-login.svg"
                  />
                </router-link>
              </div>
              <div class="col-6 my-3">
                <router-link to>
                  <img
                    class="img-fluid"
                    alt="Google Login"
                    src="@/assets/img/icons/google-login.svg"
                  />
                </router-link>
              </div>
              <div class="col-12 text-center mt-2 mb-4">
                <div class="h6 mb-0">&bull;&nbsp;OR&nbsp;&bull;</div>
              </div>
              <div class="col-12 mb-4">
                <input type="text" placeholder="Enter Email ID" class="form-control" />
              </div>
              <div class="col-12">
                <input type="text" placeholder="Enter Password" class="form-control" />
                <router-link to class="small" v-b-modal.forgotPassword>Forgot Password?</router-link>
              </div>
              <div class="col-12 mb-2">
                <div class="small text-danger font-weight-light">Invalid Email address or password</div>
              </div>
              <div class="col-12 mb-4">
                <button class="btn btn-primary w-100">LOGIN</button>
              </div>
              <div class="col-12 text-center mb-3">
                <span class="text-muted">Not a user?</span>
                <router-link to class="text-rose-gold" v-b-modal.signUp>Register with us!</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="rainbow-line">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </b-modal>

    
    <b-modal id="signUp" title="Register With Miraj" hide-footer>
      <div>
        <div class="p-3">
          <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
            <div class="row">
              <div class="col-6 my-3">
                <router-link to>
                  <img
                    class="img-fluid"
                    alt="Facebook Login"
                    src="@/assets/img/icons/facebook-login.svg"
                  />
                </router-link>
              </div>
              <div class="col-6 my-3">
                <router-link to>
                  <img
                    class="img-fluid"
                    alt="Google Login"
                    src="@/assets/img/icons/google-login.svg"
                  />
                </router-link>
              </div>

              <div class="col-12 text-center mt-2 mb-4">
                <div class="h6 mb-0">&bull;&nbsp;OR&nbsp;&bull;</div>
              </div>

              <div class="col-12 mb-4">
                <input type="email" placeholder="Enter Email ID" class="form-control" />
              </div>
              <div class="col-12 mb-4">
                <input type="number" placeholder="Enter Phone Number" class="form-control" />
              </div>
              <div class="col-12 mb-3">
                <input type="text" placeholder="Enter Password" class="form-control" />
              </div>
              <div class="col-12 mb-3">
                <b-form-checkbox class="small">
                  <div class="pt-1">
                    <span>I agree to all</span>
                    <router-link
                      to="terms-and-conditions"
                      title="Terms & Conditions"
                    >Terms & Condition</router-link>&nbsp;and
                    <router-link to="privacy-policy" title="Privacy Policy">Privacy Policy</router-link>
                  </div>
                </b-form-checkbox>
              </div>
              <div class="col-12 mb-4">
                <button class="btn btn-primary w-100">CREATE ACCOUNT</button>
              </div>
              <div class="col-12 text-center mb-3">
                <span class="text-muted">Already a user?</span>
                <router-link to class="text-rose-gold" v-b-modal.singIn>Sign In</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="rainbow-line">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </b-modal>

     
    <b-modal id="forgotPassword" title="Forgot Password" hide-footer>
      <div>
        <div class="p-3">
          <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
            <div class="row my-4">
              <div class="col-12 text-center">
                <p>Enter your Email Id to receive password reset link.</p>
              </div>
              <div class="col-12">
                <input type="email" placeholder="Enter Email ID" class="form-control" />
              </div>
              <div class="col-12 my-2">
                <div class="small text-danger font-weight-light">Invalid Email address or password</div>
              </div>
              <div class="col-12">
                <button class="btn btn-primary w-100">RESET PASSWORD</button>
              </div>
            </div>
          </div>
        </div>
        <div class="rainbow-line">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </b-modal>
    -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import MovieService from "@/apiServices/MovieService";
import ProfileService from "@/apiServices/ProfileService";
import LocationService from "@/apiServices/LocationService";
import ExtrasService from "@/apiServices/ExtrasService";
import { IMAGEURL } from "@/config";
export default {
  data() {
    return {
      unread_notification_count: null,
      usersLocation: "",
      locations: [],
      IMAGE_URL: IMAGEURL,
      searchedMovies: [],
      searchText: "",
      asideSearch: false,
      asideNavigation: false,
      locationContent: false,
      searchLocation: "",
      searchResult: false,
      locationSelected: null,
      customer_care_email: null,
      window: {
        width: 0,
        height: 0,
      },
    };
  },
  computed: {
    ...mapGetters([
      "getIsUserLogged",
      "getLoggedUser",
      "getAsideNavigation",
      "getLocation",
      "getUnreadNotificationCount",
    ]),
    plainEmail() {
      const temp = document.createElement('div');
      temp.innerHTML = this.customer_care_email;
      const link = temp.querySelector('a');
      return link ? link.textContent.trim() : '';
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.$refs.locationSearch.addEventListener(
      "blur",
      () => {
        setTimeout(() => {
          this.locationContent ? (this.locationContent = false) : undefined;
        }, 200);
      },
      true
    );

    // this.$refs.locationPopup.addEventListener(
    //   "blur",
    //   () => {
    //     setTimeout(() => {
    //       this.$bvModal.hide("locationPopup");
    //     }, 200);
    //   },
    //   true
    // );
  },
  methods: {
    openLocationPopup() {
      this.$store.dispatch("onHandleOpenModal", "cityModalModal");
    },
    getImageObject() {
      return {
        src:
          this.getLoggedUser && this.getLoggedUser.profile_image
            ? this.IMAGE_URL + this.getLoggedUser.profile_image
            : null,
        error: "../../../../frontend/src/assets/logos/logo-2.png",
        loading: "../../../../frontend/src/assets/logos/logo-2.png",
      };
    },
    ...mapActions([
      "onHandleOpenModal",
      "onHandleCloseModal",
      "onHandleToggleModal",
      "onLogoutUser",
      "onOpenAsideNavigation",
      "setLocation",
      "setCinemaID",
    ]),
    async getUnreadNotifcationCount() {
      try {
        const response = await ProfileService.GetUnreadNotificationsCount();
        const { data } = response;
        if (data && data.status) {
          this.unread_notification_count =
            data.data.total_unread_notifications_count;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getLocations(e) {
      this.usersLocation = e;
      let search = e;
      const response = await LocationService.GetLocations({ search });
      const { data } = response;
      if (data && data.status) {
        this.locations = data.data;
      }
      return null;
    },
    async handleClick({ code, type }) {
      if (type === "movie") {
        this.$router.push({
          name: "Movie Details",
          params: { movie_code: code },
        });
      } else if (type === "cinema") {
        this.$router.push({
          name: "Cinema Details",
          params: { cinema_code: code },
        });
      }
      this.searchText = "";
      this.asideSearch = false;
    },
    
    async onSearch(search) {
      const headers = { 
        "city-id" : localStorage.getItem("city_id")
      }
      if (search) {
        // const response = await MovieService.SearchMovies({ search , city_id : localStorage.getItem("city_id") });
        const response = await MovieService.SearchMovies({search});
        const { data } = response;
        if (data && data.status) {
          this.searchedMovies = data.data;
        }
      }
    },
    async handleLocationChange(city_id, city_name) {
      
      localStorage.setItem("city_id",city_id);
      this.usersLocation = city_name;
      console.log('mj', city_id);
      if (city_id && city_name) {
        this.setLocation({ city_id, city_name });
         await this.QuickBook();
        this.locationContent = false;
        this.$refs["locationPopup"].hide();
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    async getCustomerCareEmail() {
      try {
        const response = await ExtrasService.getCustomerCareEmail();
        if (response.data.status) {
          this.customer_care_email = response.data.data.extra_html_content;
        }
      } catch (err) {
        console.log("Error in getting customer care email ", err);
      }
    },
  },
  beforeMount() {
    this.getCustomerCareEmail();
    this.getLocations();
    if (this.getLocation) {
      this.usersLocation = this.getLocation;
    }
  },
};
</script>
<style>
.social-icon a {
  padding: 5px 7px;
  background: #595858;
  color: black;
  border-radius: 50%;
  cursor: pointer;
  font-size: 15px;
}
.social-icon a:hover {
  color: black !important;
}
.list-inline-item {
  margin: 5px !important;
}
.textbold {
  font-weight: 600 !important;
  color: #151515 !important;
}
/* .header-content {
  position: absolute;
  top: 4%;
  right: 6%;
} */
</style>



// WEBPACK FOOTER //
// src/components/partials/header.vue